// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"731":"b6212d3f","963":"2bda7ab5"}[chunkId] + ".chunk.js";
};